import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function ProjectPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">项目指挥台</h1>
        <p className="mt-1 text-sm text-muted-foreground">项目进度、任务权重、阻塞事项和智能体状态</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>任务看板</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">功能和图表即将实现。</p>
        </CardContent>
      </Card>
    </div>
  );
}